import { toast } from 'react-toastify';

export const warningAlert = (message) => {
    toast.warning(message, {
        position: toast.POSITION.TOP_CENTER
    });
};

export const successAlert = (message) => {
    toast.success(message, {
        position: toast.POSITION.TOP_CENTER
    });
};

export const errorAlert = (message) => {
    toast.error(message, {
        position: toast.POSITION.TOP_CENTER
    });
};
